import { useTranslation, Trans } from 'react-i18next';
import { Text, Button, Stack } from '@hotjar/hotsauce';

interface GTMConfirmProps {
  onCancel: () => void;
  onClick: () => void;
  isPublishing?: boolean;
  containerName: string;
  accountName: string;
}

export const GTMConfirm = ({
  onClick,
  onCancel,
  isPublishing = false,
  containerName,
  accountName,
}: GTMConfirmProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div>
      <Stack direction="column">
        <Stack spacing="x2" direction="column">
          <Text data-testid="confirm">
            <Trans i18nKey="activation:gtm-confirm.text">
              Once you confirm we will add your Hotjar tracking code to your site by creating a tag
              within the <b>{{ containerName }}</b> container from the <b>{{ accountName }}</b>.
            </Trans>
          </Text>
          <Text>{t('activation:gtm-confirm.helper-text')}</Text>
        </Stack>
        <Stack>
          <Button kind="secondary" onClick={onCancel}>
            {t('activation:gtm-confirm.cancel-cta')}
          </Button>
          <Button onClick={onClick} isLoading={isPublishing}>
            {t('activation:gtm-confirm.confirm-cta')}
          </Button>
        </Stack>
      </Stack>
    </div>
  );
};
